import {
  REQUEST_ADMIN_USERS,
  RECEIVE_ADMIN_USERS,
  ADD_ADMIN_USER,
  UPDATE_ADMIN_USER,
  DELETE_ADMIN_USER,
} from '../actions';

const initialState = {
  isFetching: false,
  users: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case REQUEST_ADMIN_USERS:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_ADMIN_USERS:
      return {
        ...state,
        isFetching: false,
        users: action.users,
      };
    case ADD_ADMIN_USER:
      return {
        ...state,
        users: [...state.users, action.user],
      };
    case UPDATE_ADMIN_USER:
      return {
        ...state,
        users: state.users.map((user) => {
          if (user.id === action.user.id) return action.user;
          return user;
        }),
      };
    case DELETE_ADMIN_USER:
      return {
        ...state,
        users: state.users.filter(user => user.id !== action.id),
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/adminReducer.js